import { render } from "./AddActionCommentComponent.vue?vue&type=template&id=f158d416"
import script from "./AddActionCommentComponent.vue?vue&type=script&lang=js"
export * from "./AddActionCommentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__